import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';

interface CreditoOption {
  title: string;
  description: string;
  icon: string;
  route?: string;
  action?: string;
  requiredRoles: string[];
  color: string; // Tailwind color class
  rbacPermissions?: string[];
}

@Component({
  selector: 'app-credito-dashboard',
  templateUrl: './credito-dashboard.component.html',
  styleUrls: []
})
export class CreditoDashboardComponent implements OnInit {
  options: CreditoOption[] = [
    {
      title: 'Políticas de Aprobación',
      description: 'Configura y gestiona las políticas de aprobación de créditos',
      icon: 'fas fa-clipboard-check',
      route: '/console/approval-policies',
      requiredRoles: ['OWNER'],
      color: 'bg-blue-100 text-blue-600',
      rbacPermissions: ['credito.politicas_aprobacion.read']
    },
    {
      title: 'Estatus de Aprobación',
      description: 'Monitorea el estado de aprobación y progreso de cada cliente en el sistema',
      icon: 'fas fa-chart-line',
      route: '/console/constacts-status',
      requiredRoles: [],
      color: 'bg-blue-100 text-blue-600',
      rbacPermissions: ['credito.estatus.read']
    },
    {
      title: 'Registro de clientes',
      description: 'Visualiza estadísticas y registros detallados de todos los clientes del sistema',
      icon: 'fas fa-users',
      route: '/console/client-stadistic',
      requiredRoles: [],
      color: 'bg-blue-100 text-blue-600',
      rbacPermissions: ['credito.registro.read']
    },
    {
      title: 'Carga masiva de Clientes',
      description: 'Importa grandes volúmenes de clientes mediante archivos Excel',
      icon: 'fas fa-upload',
      route: '/console/carga-masiva-cleinte-xlsx',
      requiredRoles: ['OWNER'],
      color: 'bg-blue-100 text-blue-600',
      rbacPermissions: ['credito.carga_masiva.read']
    },
    {
      title: 'Aprobación masiva de clientes',
      description: 'Procesa aprobaciones en lote para agilizar operaciones administrativas',
      icon: 'fas fa-check-double',
      route: '/console/carga-masiva-aprobaciones-xlsx',
      requiredRoles: ['OWNER'],
      color: 'bg-blue-100 text-blue-600',
      rbacPermissions: ['credito.aprobacion_masiva.read']
    },
    {
      title: 'Aumento masivo de cupos',
      description: 'Incrementa límites de crédito de múltiples clientes simultáneamente',
      icon: 'fas fa-arrow-up',
      route: '/console/carga-masiva-cupos',
      requiredRoles: ['OWNER'],
      color: 'bg-blue-100 text-blue-600',
      rbacPermissions: ['credito.aumento_cupos.read']
    },
    {
      title: 'Inactivación Masiva de Cupos',
      description: 'Suspende o inactiva múltiples cupos de crédito de forma masiva',
      icon: 'fas fa-ban',
      route: '/console/inactivate-quota',
      requiredRoles: ['OWNER'],
      color: 'bg-blue-100 text-blue-600',
      rbacPermissions: ['credito.inactivacion_cupos.read']
    },
    {
      title: 'Historial de cambios de cupo',
      description: 'Consulta el historial de cambios de cupo por ejecutivo con filtros de fecha',
      icon: 'fas fa-history',
      route: '/console/credito/quota-history-global',
      requiredRoles: [],
      color: 'bg-blue-100 text-blue-600',
      rbacPermissions: ['credito.historial_cupo.read']
    },
    {
      title: 'Carga Masiva de etiquetas',
      description: 'Asigna etiquetas únicas a personas de forma masiva y automatizada',
      icon: 'fas fa-qrcode',
      route: '/console/code-dynamic',
      requiredRoles: ['OWNER'],
      color: 'bg-blue-100 text-blue-600',
      rbacPermissions: ['credito.etiquetas.read']
    },
    {
      title: 'Carga Masiva de Fees de Reactivación',
      description: 'Procesa fees de reactivación (C004) de forma masiva mediante archivo Excel',
      icon: 'fas fa-file-invoice-dollar',
      route: '/console/credito/reactivaciones-masivas',
      requiredRoles: ['OWNER'],
      color: 'bg-green-100 text-green-600',
      rbacPermissions: ['credito.carga_masiva_fees.read']
    }
  ];

  userRoles: string[] = [];

  constructor(public _auth: AuthService) {}

  ngOnInit(): void {
    this.userRoles = Array.isArray(this._auth.sessionUser?.profile) ? this._auth.sessionUser.profile : [];
  }

  hasPermission(option: CreditoOption): boolean {
    if (this._auth.hasRbac$.getValue()) {
      if (option.rbacPermissions && option.rbacPermissions.length > 0) {
        return this._auth.hasAnyPermission(option.rbacPermissions);
      }
      return this._auth.hasModuleAccess('credito');
    }
    if (!option.requiredRoles || option.requiredRoles.length === 0) return true;
    return option.requiredRoles.some(role => this.userRoles.includes(role));
  }
}
